import { Link } from "react-router-dom";

import { useTranslation } from "@/shared/hooks";
import { AuthComponent } from "../AuthComponent";
import type { AuthCardProps } from "../../types/auth.types";

import logoUrl from "@/shared/ui/icons/apaato_logo_light.svg";

export function AuthCard({
  title,
  logo,
  className,
  ...authProps
}: AuthCardProps) {
  const t = useTranslation();

  // Keep current LoginPage visual style by default.
  const resolvedTitle =
    title ??
    (authProps.initialMode === "register" ? t("register") : t("signIn"));
  const resolvedLogo = logo ?? (
    <img src={logoUrl} alt="Apaato logo" className="w-14 h-14" />
  );

  return (
    <div
      className={`max-w-md w-full bg-white rounded-2xl p-8 shadow-2xl z-10 ${className ?? ""}`.trim()}
    >
      <div className="text-center">
        <Link
          to="/"
          className="text-4xl font-bold text-gray-800 inline-flex items-center gap-1"
        >
          {resolvedLogo}
          Apaato
        </Link>
        <h2 className="mt-6 text-2xl font-bold text-gray-800">
          {resolvedTitle}
        </h2>
      </div>

      <AuthComponent {...authProps} />
    </div>
  );
}
